import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ResponseTermsConditions } from '../../../../shared/interfaces/termsConditions.interface';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class TermsConditionsHandler {
  constructor(
    private http: HttpClient
  ) { }

  getTexts(): Observable<ResponseTermsConditions> {
    const endpoint = environment.staticScripts.staticAssets + 'json/terms-and-conditions.json';
    return this.http.get<ResponseTermsConditions>(endpoint);
  }
}
